import "../assets/scss/portraitFrame.scss";

import { observer } from "mobx-react";
import { Breadcrumb } from "react-bootstrap";

import { IImageService } from "../services/image/IImageService";
import { DictionaryStore } from "../stores/dictionary/DictionaryStore";
import { ILoanWordsStore, WordFilter } from "../stores/word/LoanWordsStore";
import { DomUtils } from "../utils/DomUtils";
import { WordTooltip } from "./WordTooltip";

import React = require("react");
type Props = {
  filter: WordFilter;
  wordStore: ILoanWordsStore;
  dictionaryStore: DictionaryStore;
  imageService: IImageService;
  renderSidePanel: (filter: WordFilter, includeHeader: false) => JSX.Element;
  renderWordList: (filter: WordFilter) => JSX.Element;
};

enum FilterKind {
  None,
  ByLanguage,
  ByWord
}

const headerContainerCssClass = "portraitFrame-header-container";

@observer
export class PortraitFrame extends React.Component<Props, undefined> {
  render() {
    return (
      <div>
        <div className={headerContainerCssClass} ref={this.bindHeaderContainer}>
          {this.renderHeaderText()}
          {this.renderBreadCrumbs()}
        </div>
        <div className="portraitFrame-body-container">{this.renderParts()}</div>
      </div>
    );
  }

  private bindHeaderContainer = (element: HTMLDivElement | null) => {
    if (element) {
      DomUtils.setAllParentsToFullHeight(element);
    }
  };

  private renderHeaderText = () => {
    return <h1 className="portraitFrame-pageHeader">Loan Words</h1>;
  };

  private renderBreadCrumbs = () => {
    const { filter } = this.props;

    const originalLanguage = filter.originalLanguage;
    const originalWord = filter.originalWord;

    return (
      <Breadcrumb className="portraitFrame-breadcrumb">
        <Breadcrumb.Item href="#/filter" active={!originalLanguage}>
          All languages
        </Breadcrumb.Item>
        {originalLanguage && (
          <Breadcrumb.Item
            href={`#/filter/${originalLanguage}`}
            active={!originalWord}
          >
            {originalLanguage}
          </Breadcrumb.Item>
        )}
        {originalWord && (
          <Breadcrumb.Item active={!!originalWord}>
            {originalWord}
          </Breadcrumb.Item>
        )}
      </Breadcrumb>
    );
  };

  private renderParts = () => {
    const { filter } = this.props;

    /*
    no filter -> show sidepanel only
    language -> show bottom only
    word -> show tooltip only
    */

    switch (this.filterKind) {
      case FilterKind.None:
        return this.props.renderSidePanel(filter, false);
      case FilterKind.ByLanguage:
        return this.props.renderWordList(filter);
      case FilterKind.ByWord:
        return this.renderWord(filter);
      default:
        throw new Error("unhandled FilterKind!");
    }
  };

  private get filterKind(): FilterKind {
    const { filter } = this.props;

    if (!filter.originalLanguage && !filter.originalWord) {
      return FilterKind.None;
    }

    if (filter.originalLanguage && !filter.originalWord) {
      return FilterKind.ByLanguage;
    }

    if (filter.originalWord) {
      return FilterKind.ByWord;
    }

    throw new Error("unhandled portrait scenario!");
  }

  private renderWord = (filter: WordFilter) => {
    const { dictionaryStore, wordStore, imageService } = this.props;

    const isLoaded = wordStore.allWords.length > 0;

    return (
      isLoaded && (
        <WordTooltip
          dictionaryStore={dictionaryStore}
          filter={filter}
          wordStore={wordStore}
          imageService={imageService}
        />
      )
    );
  };
}



// WEBPACK FOOTER //
// ./components/PortraitFrame.tsx